const myEventsListing = () =>
  import("@/components/dashboard/cme/myEventsListing");
export default [
  {
    path: "",
    name: "dashboard.events.root",
    redirect: {
      name: "dashboard.events.myEventsListing"
    }
  },
  {
    path: "myEventsListing",
    name: "dashboard.events.myEventsListing",
    component: myEventsListing
  },
  {
    path: "eventDetails/:slug",
    name: "dashboard.events.eventDetails",
    component: () => import("@/components/dashboard/cme/eventdetails")
  },
  {
    path: "createEvent",
    name: "dashboard.events.createEvent",
    component: () => import("@/components/dashboard/cme/createEvent")
  },
];
